<template>
</template>

<script>
import salesOrderPrintHTML from '@/views/sales/salesOrders/SalesSalesOrdersPrintHTML'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'SalesSalesOrdersPrint',
  mixins: [salesOrderPrintHTML,printHtml],
  props: {
    salesOrder: {type:Object, required:false},
    salesOrders: {type:Array, required:false}
  },
  data() {
    return {
      company: null,
    }
  },
  async created() {
    this.$emit('done');
    if (!this.salesOrder && !this.salesOrders)
      return;
    const results = await this.$apiCall(`query SalesSalesOrdersPrint {
                                            company {name,address,city,province,postalCode,email,phone,logoURL}
                                          }`,
                                        {});
    if (results.error)
      return;
    this.company = results.data.company;

    const lines = [];
    const logos = this.company.logoURL ? [] : null;
    const salesOrders = this.salesOrder ? [this.salesOrder] : this.salesOrders;
    let n = salesOrders.length - 1;
    for (const salesOrder of salesOrders) {
      lines.push(await this.printSalesOrder(salesOrder.id));
      if (n--)
        lines.push(`<div class="page-break"/>`);
      if (logos)
        logos.push({id:salesOrder.id, src:this.company.logoURL});
    }
    this.printHtml(`Sales order ${this.salesOrder?this.salesOrder.number:''}`, lines.join(''), logos);
  },
  methods: {
    async printSalesOrder(id) {
      const results = await this.$apiCall(`query SalesSalesOrdersPrint($id:ID!) {
                                              salesOrder(id:$id) {
                                                id,date,due,number,po,term,shipVia,shipToAddress,billToAddress,memo,taxInclusive,customerLicense
                                                lines {
                                                  sku,description,taxCodeId,quantity,unitPrice,amount,precision
                                                  items {sku,description,quantity,units,precision}
                                                }
                                                taxLines {
                                                  id,name,amount,onAmount,percent
                                                }
                                                discount {percent,amount,value}
                                              }
                                            }`,
                                          {id});
      if (results.error)
        return;
      const salesOrder = results.data.salesOrder;
      return this.print(this.company, salesOrder);
    }
  }
}
</script>